import classNames from 'classnames';
import { useCallback } from 'react';

export const MULTI_COLUMN_DEFAULT_BREAKPOINT = 'md';
// On every wrapper that can put its children side by side, for a surface above it to line up with.
export const MULTI_COLUMN_CLASS = 'MCW-columns';
const rootCss = ({ breakpoints, constants, spacing }, minColumnWidth) => {
  const columnStyles = {
    overflow: 'auto',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '& > *': {
      width: '100%',
      maxWidth: constants.WRAPPER_MAX_WIDTH_MD,
      flex: '0 0 auto',
      overflow: 'initial',
    },
  };
  const multiColumnStyles = {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'stretch',

    '& > *': {
      flex: 1,
      width: '100%',
      maxWidth: constants.WRAPPER_MAX_WIDTH_MD,
      overflow: 'auto',
      containerType: 'inline-size',
    },
  };

  const defaultStackPx = breakpoints.values[MULTI_COLUMN_DEFAULT_BREAKPOINT];
  const gapPx = parseInt(spacing(1));
  const stackPx = Math.max(minColumnWidth * 2 + gapPx + gapPx * 2, defaultStackPx);

  return {
    display: 'flex',
    minHeight: 0,
    flex: 1,
    padding: spacing(1),
    gap: spacing(1),
    '&.root_default': {
      ...multiColumnStyles,
      [`@media (max-width: ${stackPx}px)`]: columnStyles,
      [`@container (max-width: ${stackPx}px)`]: columnStyles,
    },
    '&.root_multiColumn': multiColumnStyles,
    '&.root_singleColumn': columnStyles,
  };
};

export default function MultiColumnContentsWrapper(props) {
  const { children, className, minColumnWidth, variant = 'default' } = props;
  const css = useCallback(theme => rootCss(theme, minColumnWidth || 0), [minColumnWidth]);
  return (
    <div
      className={classNames(className, `root_${variant}`, { [MULTI_COLUMN_CLASS]: variant !== 'singleColumn' })}
      css={css}
    >
      {children}
    </div>
  );
}
